import $ from "jquery";

$(function () {
    $(".content img[alt]").each(function () {
        const $img = $(this);
        const altText = $img.attr("alt").trim();
        if (altText) {
            const floatStyle = $img.css("float");
            $img.wrap("<figure></figure>").after("<figcaption>" + altText + "</figcaption>");
            if (floatStyle) {
                $img.parent("figure").css("float", floatStyle);
            }
        }
    });


    //Accessability fixes
    $('.select2-container input.select2-search__field').attr('aria-label', 'Select');

    $('label[for]').each(function () {
        const $label = $(this);
        const forId = $label.attr('for');
        const $select = $('#' + forId);

        if ($select.length && $select.hasClass('select2-hidden-accessible')) {
            const labelId = 'label-' + forId;
            $label.removeAttr('for').attr('id', labelId);

            const $selection = $select.siblings('.select2').find('.select2-selection');
            $selection.removeAttr('aria-labelledby').attr('aria-labelledby', labelId);
        }
    });

    $('span.flatpickr-day').each(function () {
        const $el = $(this);
        const hasAriaLabel = $el.is('[aria-label]');
        const isDisabled = $el.hasClass('flatpickr-disabled');
        const isNotFocusable = $el.attr('tabindex') === "-1";
        const hasNoRole = !$el.attr('role');

        if (hasAriaLabel && (isDisabled || isNotFocusable || hasNoRole)) {
            $el.removeAttr('aria-label');
        }
    });
});
$('.select2-hidden-accessible').each(function () {
    const $select = $(this);
    const selectId = $select.attr('id');
    const resultsId = 'select2-' + selectId + '-results';

    const $selection = $select.siblings('.select2').find('.select2-selection');
    const $rendered = $select.siblings('.select2').find('.select2-selection__rendered');

    if ($selection.length) {
        $selection.attr('aria-controls', resultsId);

        // Create dummy container to prevent ARC "missing ID"
        if (!document.getElementById(resultsId)) {
            $('<ul>', {
                id: resultsId,
                role: 'listbox',
                class: 'select2-results__options',
                'aria-hidden': 'true',
                hidden: true,
                style: 'display: none;',
            }).appendTo('body');
        }
    }

    if ($rendered.length) {
        const isEmpty = $rendered.text().trim() === '';
        const isLabeled = $rendered.is('[title]') || $rendered.is('[aria-labelledby]');

        if (isEmpty && !isLabeled) {
            $rendered.attr('title', 'Select');
        }
    }
});

$('.select2-selection__rendered:not([title])').each(function () {
    $(this).attr('title', $(this).text());
});

function alignOffsetForm() {
    const $offsetForm = $('.offset-form');

    if ($offsetForm.length === 0) return;

    const isLargeScreen = $(window).width() >= 992;
    const $leftItems = $('.left-side .list-group-item');
    const $rightItems = $('.right-side .list-group-item');

    let marginTop = '0';

    if (isLargeScreen && $leftItems.length > 0 && $rightItems.length === 0) {
        let totalHeight = 0;

        $leftItems.each(function () {
            totalHeight += $(this).outerHeight(true);
        });

        marginTop = `-${totalHeight}px`;
    }

    $offsetForm
        .css({
            'margin-top': marginTop,
            'visibility': 'visible'
        });
}

$(document).ready(function () {
    alignOffsetForm();
    $(window).on('resize', function () {
        alignOffsetForm();
    });
});

$(document).on('click', '.button-wrapper', function (e) {
    const $checkbox = $('[id^="rule_confirm"]');

    if ($checkbox.length) {
        if (!$checkbox.is(':checked')) {
            e.preventDefault();
            $checkbox.addClass('is-invalid').focus();
        } else {
            $checkbox.removeClass('is-invalid');
            $(this).find('button[name="rule"]')[0].click();
        }
    }
});
